import { render, staticRenderFns } from "./DoubleBooking.vue?vue&type=template&id=99b90606"
import script from "./DoubleBooking.vue?vue&type=script&lang=js"
export * from "./DoubleBooking.vue?vue&type=script&lang=js"
import style0 from "./DoubleBooking.vue?vue&type=style&index=0&id=99b90606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports